import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=ba7e8ef8&"
import script from "./Game.vue?vue&type=script&lang=js&"
export * from "./Game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports